import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api, getToken, setToken } from '../api/client';

const AuthContext = createContext(null);
const EMPRESA_ATUAL_KEY = 'coren_empresa_atual';

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [empresas, setEmpresas] = useState([]);
  const [empresaAtualId, setEmpresaAtualId] = useState(() => {
    const salva = localStorage.getItem(EMPRESA_ATUAL_KEY);
    return salva ? Number(salva) : null;
  });

  const carregarEmpresas = useCallback(async () => {
    try {
      const lista = await api.get('/empresas/minhas');
      setEmpresas(lista);
      setEmpresaAtualId(atual => {
        if (atual && lista.some(e => e.id === atual)) return atual;
        return lista[0] ? lista[0].id : null;
      });
    } catch (e) {
      setEmpresas([]);
    }
  }, []);

  const carregarSessao = useCallback(async () => {
    if (!getToken()) { setCarregando(false); return; }
    try {
      const { usuario } = await api.get('/auth/me');
      setUsuario(usuario);
      await carregarEmpresas();
    } catch (e) {
      setToken(null);
    } finally {
      setCarregando(false);
    }
  }, [carregarEmpresas]);

  useEffect(() => { carregarSessao(); }, [carregarSessao]);

  useEffect(() => {
    const aoExpirar = () => setUsuario(null);
    window.addEventListener('coren:sessao-expirada', aoExpirar);
    return () => window.removeEventListener('coren:sessao-expirada', aoExpirar);
  }, []);

  const login = async (email, senha) => {
    const resposta = await api.post('/auth/login', { email, senha });
    setToken(resposta.token);
    setUsuario(resposta.usuario);
    await carregarEmpresas();
    return resposta.usuario;
  };

  const logout = () => {
    setToken(null);
    setUsuario(null);
    setEmpresas([]);
    setEmpresaAtualId(null);
    localStorage.removeItem(EMPRESA_ATUAL_KEY);
  };

  const trocarEmpresa = (id) => {
    setEmpresaAtualId(id);
    localStorage.setItem(EMPRESA_ATUAL_KEY, String(id));
  };

  const empresaAtual = empresas.find(e => e.id === empresaAtualId) || null;

  return (
    <AuthContext.Provider value={{
      usuario,
      carregando,
      tenantId: usuario ? usuario.tenant_id : null,
      perfil: usuario ? usuario.perfil : null,
      empresas,
      empresaAtual,
      empresaAtualId,
      trocarEmpresa,
      regimeTributario: empresaAtual ? empresaAtual.regime_tributario : null,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
